import * as React from 'react';

import { PageTitle } from './PageTitle';

import { useApplication } from '../AppContext';

import './Test.css';

const Test = () => {
	const app = useApplication();
	const { userdata: { isMuted, removeAds, fullVersion } } = app;

	const handleShowNotification = React.useCallback(() => {
		app.showNotification({
			title: 'Test',
			type: 'Achievement',
			image: 'https://picsum.photos/200/300',
			points: 25,
			description: 'Test description',
		});
	}, [app]);

	const handleSound = React.useCallback(() => {
		app.setIsMuted(!app.userdata.isMuted);
	}, [app]);

	const handleAds = React.useCallback(() => {
		app.setRemoveAds(!removeAds);
		app.showNotification(`removeAds =  ${app.userdata.removeAds}`);
	}, [app, removeAds]);

	return (
		<div id="Profile" className="page1 test-page">
			<div className="wrapperMedium">
				<PageTitle>
					<h1>Test</h1>
				</PageTitle>
				<div className="test-row">
					<span>Privacy choices (Settings action)</span>
					<button onClick={() => app.portal.showPrivacyOptions()}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>UMP consent (if required)</span>
					<button onClick={() => app.portal.gatherConsent?.()}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>ATT (iOS only)</span>
					<button onClick={() => app.portal.requestTrackingAuthorization?.()}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>Ad</span>
					<button onClick={() => {
						app.showAd(true);
					}}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>GameUI: Test vs Easy</span>
					<button onClick={() => {
						app.navigate('Game/Test/Easy');
					}}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>GameUI: Test vs Medium</span>
					<button onClick={() => {
						app.navigate('Game/Test/Medium');
					}}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>GameUI: Test vs Hard</span>
					<button onClick={() => {
						app.navigate('Game/Test/Hard');
					}}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>GameUI: Test vs Crazy Ninja</span>
					<button onClick={() => {
						app.navigate('Game/Test/CrazyNinja');
					}}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>Enjoy dialog</span>
					<button onClick={() => {
						app.showEnjoyGame();
					}}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>Share</span>
					<button onClick={() => {
						app.showShare();
					}}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>Notification</span>
					<button onClick={() => {
						app.showNotification('Test notification');
					}}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>Achievement notification</span>
					<button onClick={handleShowNotification}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>Fetch Pixaroma deck image</span>
					<button onClick={() => {
						fetch('assets/decks/PixaromaDeck_SpriteSheet.png').then((response) => {
							console.log(response);
						}).catch((error) => {
							console.log(error);
						});
					}}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>Turn sound {isMuted ? 'On' : 'Off'}</span>
					<button onClick={handleSound}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>Toggle ads</span>
					<button onClick={handleAds}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>{fullVersion ? 'Disable' : 'Enable'} full version</span>
					<button onClick={() => {
						app.userdata.fullVersion = !fullVersion;
						app.showNotification(`fullVersion =  ${app.userdata.fullVersion}`);
						app.save();
					}}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>Full version purchase</span>
					<button onClick={() => {
						app.iap.buy('com.jdsoftwarellc.hearts.fullversion');
					}}>
						Run
					</button>
				</div>
				<div className="test-row">
					<span>Delete user data</span>
					<button onClick={() => {
						app.userdata = {};
						app.showNotification(`userdata deleted`);
						app.save();
					}}>
						Run
					</button>
				</div>
			</div>
		</div>
	);
};

export default Test;
